import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductFabricClassTwoAsync,
  deleteProductFabricClassTwoAsync,
  editProductStyleAsync,
  editProductFabricClassTwoAsync,
  getProductStyleAsync,
  getProductFabricClassTwoAsync,
} from "../../../../store/services/productInfoServices";
const FabricClassTwo = () => {
  const dispatch = useDispatch();
  const {
    getProductFabricClassTwoStatus,
    getProductFabricClassTwoError,
    getProductFabricClassTwoData,
    addProductFabricClassTwoStatus,
    addProductFabricClassTwoData,
    addProductFabricClassTwoError,

    editProductFabricClassTwoStatus,
    editProductFabricClassTwoError,
    editProductFabricClassTwoData,

    deleteProductFabricClassTwoData,
    deleteProductFabricClassTwoStatus,
    deleteProductFabricClassTwoError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductFabricClassTwoAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductFabricClassTwoData?.length
    ? getProductFabricClassTwoData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedFabricClassTwo, setSelectedFabricClassTwo] = useState();
  const [addFabricClassTwoMode, setAddFabricClassTwoMode] = useState(false);
  const [addFabricClassTwoData, setAddFabricClassTwoData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedFabricClassTwo", selectedFabricClassTwo);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductFabricClassTwoStatus === asyncStatus.SUCCEEDED) {
      setAddFabricClassTwoMode(false);
      setSaveDisabled(true);
      setAddFabricClassTwoData();
    }
  }, [, addProductFabricClassTwoStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductFabricClassTwoAsync(selectedFabricClassTwo?.fabric_class_id2));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductFabricClassTwoStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedFabricClassTwo();
    }
  }, [, deleteProductFabricClassTwoStatus]);
  useEffect(() => {
    if (editProductFabricClassTwoStatus === asyncStatus.SUCCEEDED) {
      setSelectedFabricClassTwo();
      setEditMode(false);
    }
  }, [, editProductFabricClassTwoStatus]);
console.log("getProductFabricClassTwoData",getProductFabricClassTwoData,editProductFabricClassTwoData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this fabric class 2?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Fabric Class 2"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Fabric Class 2 Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddFabricClassTwoMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addFabricClassTwoMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addFabricClassTwoMode || !selectedFabricClassTwo}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddFabricClassTwoMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addFabricClassTwoMode || !selectedFabricClassTwo}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductFabricClassTwoStatus === asyncStatus.LOADING ||
                  editProductFabricClassTwoStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addFabricClassTwoData) {
                    dispatch(addProductFabricClassTwoAsync(addFabricClassTwoData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedFabricClassTwo, ...editData };
                    delete a.id;
                    dispatch(editProductFabricClassTwoAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "fabric_class_id2", headerName: "ID", flex: true },
                  {
                    field: "fabric_class_name2",
                    headerName: "Fabric Class 2 Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedFabricClassTwo(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductFabricClassTwoStatus === asyncStatus.IDLE ||
                  getProductFabricClassTwoStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addFabricClassTwoMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Fabric Class 2:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddFabricClassTwoData({
                            ...addFabricClassTwoData,
                            fabric_class_name2: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddFabricClassTwoData({
                            ...addFabricClassTwoData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedFabricClassTwo ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedFabricClassTwo?.fabric_class_id2}
                      </Typography>
                    ),
                  },
                  {
                    label: "Fabric Class 2:",
                    comp: (
                      <InputComp
                        key={selectedFabricClassTwo?.fabric_class_id2} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            fabric_class_name2: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedFabricClassTwo?.fabric_class_name2}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedFabricClassTwo?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedFabricClassTwo?.is_active ? true : false
                        }
                        checked={selectedFabricClassTwo?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any fabric class two</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductFabricClassTwoError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductFabricClassTwoError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductFabricClassTwoError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductFabricClassTwoError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedFabricClassTwo(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedFabricClassTwo(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default FabricClassTwo;
